import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'modal-header',
	template: require('./modal-header.component.html'),
})
export class ModalHeaderComponent {
	@Input() title: string;
	@Input() isFirstStep: boolean;
	@Input() isSecondary: boolean = false;
	@Output() emitCloseModal = new EventEmitter();
	@Output() emitMoveBackStep = new EventEmitter();
	@Input() hasBackButton: boolean = true;
	@Input() hasStepper: boolean = true;
	@Input() isXLarge: boolean = false;
	public isRebrading = AppSettings.isRebrading;

	closeModal(): void {
		this.emitCloseModal.emit();
	}

	moveBackStep(): void {
		this.emitMoveBackStep.emit();
	}
	constructor() {}
}
